import { Link } from "react-router-dom";
import { BrandLogo, Container, LandingButton, SIGN_IN_PATH, SIGN_UP_PATH } from "./primitives";

const NAV_LINKS = [
  { label: "Product",           href: "#features"      },
  { label: "Security",          href: "#security"      },
  { label: "For Organizations", href: "#organizations" },
];

export function LandingHeader() {
  return (
    <header className="sticky top-0 z-50 border-b border-[#EEEFF3]/70 bg-white/70 backdrop-blur-md">
      <Container size="narrow" className="flex h-[68px] items-center justify-between gap-6">
        <Link to="/about" aria-label="MedSyncIQ home">
          <BrandLogo />
        </Link>

        <nav className="hidden items-center gap-[30px] lg:flex">
          {NAV_LINKS.map(link => (
            <a
              key={link.href}
              href={link.href}
              className="text-[14px] font-medium text-[#374151] transition-colors hover:text-[#120240]"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-6">
          <Link to={SIGN_IN_PATH} className="text-[14px] font-semibold text-[#120240] hover:text-[#F18095]">
            Log In
          </Link>
          <LandingButton to={SIGN_UP_PATH} className="!h-[38px] !px-5 !text-[14px]">
            Get Started Free
          </LandingButton>
        </div>
      </Container>
    </header>
  );
}
